var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CzechRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M28.067,24.004L8.565,36.719C12.233,41.166,17.786,44,24,44c11.046,0,20-8.954,20-20H28.06 L28.067,24.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7dfe2",
    d: "M24,4c-6.215,0-11.768,2.835-15.436,7.282L28.06,24H44C44,12.954,35.046,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M28.06,24L8.564,11.282C5.713,14.739,4,19.169,4,24c0,4.831,1.713,9.262,4.565,12.719l19.502-12.715 L28.06,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CzechRepublic);
export default __webpack_public_path__ + "static/media/icons8-czech-republic.529ca9aa1cbc849258d0dc4b603a8ffe.svg";
export { ForwardRef as ReactComponent };